const labels = {
  FaqCategories: {
    'Ref: Page title': '자주하는 질문',
    'Ref: Missing Faq': 'FAQ 비어',
    'Ref: Go to home page': '홈페이지로 이동하십시오',
  },
  FaqCategoryDetails: { 'Ref: Page title': '질문' },
};
export default labels;
